import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitle";
import brandLogo from "../../pages/home/components/img/brands/logo-nypd.png"; 
import phoneImage from "../../pages/home/components/img/brands/NYPD-Pizza-phone-mockup.png";
import metric1 from "../../pages/home/components/img/brands/pizza-metric-1.png";
import metric2 from "../../pages/home/components/img/brands/pizza-metric-2.png";
import metric3 from "../../pages/home/components/img/brands/pizza-metric-3.png";
import menu1 from "../../pages/home/components/img/brands/pizza-menu-1.png";
import menu2 from "../../pages/home/components/img/brands/pizza-menu-2.png";
import menu3 from "../../pages/home/components/img/brands/pizza-menu-3.png";
import deliveryPartners from "../../pages/home/components/img/brands/delivery-partners.png";
import ctaImage from "../../pages/home/components/img/brands/pizza-cta-image.png";
import otherBrand1 from "../../pages/home/components/img/brands/brand-3.png";
import otherBrand2 from "../../pages/home/components/img/brands/brand-2.png";
import otherBrand3 from "../../pages/home/components/img/brands/brand-1.png";
import "./NypdPizza.scss";
import videoFile from "../../pages/home/components/videos/nypdpizza.mp4"; // ✅ Correctly placed import

const NYPDPizza = () => {
  return (
    <div className="nypd-pizza-page">
      
     {/* Hero Section */}
     <section className="hero-section">
        <div className="container text-center">
          <img src={brandLogo} alt="Just Chicken Wings Logo" className="brand-logo" />
          <h1>Bring NYPD Pizza to your area</h1>

          {/* Video Section */}
          <div className="video-container">
            <video className="hero-video" controls>
              <source src={videoFile} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          
        </div>
      </section>
 

     {/* Business Value Proposition Section */}
<section className="business-section">
  <div className="container">
    <div className="business-content">
      <img src={phoneImage} alt="Order Just Chicken Wings" className="phone-mockup" />
      <div className="business-text">
        <h2>Satisfy Your Pizza Cravings</h2>
        <p>
		NYPD Pizza brings the authentic taste of New York-style pizza straight to your customers. Our hand-tossed dough, rich tomato sauce, and premium cheese create a classic, mouth-watering experience that keeps customers coming back for more
        </p>
      </div>
    </div>
  </div>
</section>


      {/* Key Metrics / Achievements Section */}
      <section className="metrics-section">
        <div className="container text-center">
          <div className="metrics">
            <img src={metric1} alt="Sales" />
            <p>2M+ Pizza Sold</p>
          </div>
          <div className="metrics">
            <img src={metric2} alt="Customers" />
            <p>Authentic New York Flavor</p>
          </div>
          <div className="metrics">
            <img src={metric3} alt="Years in Business" />
            <p>7 Years of Excellence</p>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section">
        <div className="container text-center">
          <blockquote>
		  "Adding NYPD Pizza to my restaurant was a game-changer! Our orders skyrocketed, and customers love the authentic New York-style taste!"
          </blockquote>
          <cite>– Michael, Boynton Beach Restaurant Owner</cite>
        </div>
      </section>

      {/* Popular Menu Items / Featured Dishes Section */}
      <section className="menu-section">
        <div className="container">
          <h2>Fan Favorites</h2>
          <div className="menu-items">
            <div className="menu-card">
              <img src={menu1} alt="Buffalo Wings" />
              <h3>House Special Pizza</h3>
              <p>A signature blend of premium toppings, fresh mozzarella, and our secret NYPD sauce, baked to perfection on a hand-tossed crust.</p>
            </div>
            <div className="menu-card">
              <img src={menu2} alt="Garlic Parmesan Wings" />
              <h3>Pepperoni Perfection</h3>
              <p>Classic New York-style pepperoni pizza with crispy, slightly curled edges and a perfectly balanced sauce-to-cheese ratio.</p>
            </div>
            <div className="menu-card">
              <img src={menu3} alt="BBQ Wings" />
              <h3>Original Cheese Pizza</h3>
              <p>A timeless favorite—golden, bubbly mozzarella layered over rich tomato sauce on a perfectly baked crust.</p>
            </div>
          </div>
        </div>
      </section>

   {/* Delivery Platforms Section */}
<section className="delivery-section">
  <div className="container">
    <div className="text-content">
      <h2>Available on Hey Jag Customer App</h2>
      <p>
        NYPD Pizza is available exclusively on <strong>Hey Jag customer App</strong>, 
        the revolutionary delivery platform that offers lower fees, better service, 
        and direct support for restaurants. Customers can easily order their favorite 
        wings with faster delivery and seamless tracking.
      </p>
      <Link to="/delivery" className="cmn-btn">
          <span>Learn More</span></Link>
    </div>
    <div className="delivery-logos">
      <img src={deliveryPartners} alt="Delivery Partners on Hey Jag" />
      
    </div>
  </div>
</section>



     {/* Call-to-Action (CTA) Section */}
<section className="cta-section">
  <div className="container text-center">
    <h2>That’s a Wrap!</h2>
    <p>Start running NYPD Pizza from your kitchen today.</p>
    <img src={ctaImage} alt="Join Now" className="cta-image" />  {/* Image with reduced size ✅ */}
    <a
      href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3bx6kbQqtu-wVjgCL2H26Z16mSbWqgSAt5J-bVWbFdx6o_jy0Knt21nnGAvFeQfaJpx7LtZld7?gv=true"
      target="_blank"
      rel="noopener noreferrer"
      className="cmn-btn"
    >
      <span>Take The First Step</span>
    </a>
  </div>
</section>


      {/* Explore Other Brands Section */}
      <section className="other-brands-section">
        <div className="container">
          <h2>Not your flavor? Explore other brands:</h2>
          <div className="other-brands">
            <div className="brand-card">
              <img src={otherBrand1} alt="Brand 1" />
              <h3>BFF Burgers</h3>
              <Link to="/brands/bff" className="cmn-btn">
              <span>LEARN MORE</span></Link>
            </div>
            <div className="brand-card">
              <img src={otherBrand2} alt="Brand 3" />
              <h3>The Imperial Bamboo</h3>
              <Link to="/brands/the-imperial-bamboo" className="cmn-btn">
              <span>LEARN MORE</span></Link>
              </div>
            <div className="brand-card">
              <img src={otherBrand3} alt="Brand 1" />
              <h3>Just Chicken Wings</h3>
              <Link to="/brands/just-chicken-wings" className="cmn-btn">
              <span>LEARN MORE</span></Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default NYPDPizza;